angular.module 'zc.commonApi'

.factory 'CampaignEventStats', (FacadeV2) ->

  class CampaignEventStats

    @aggregate: (paths, params) ->
      FacadeV2.request "/apikeys/#{paths.apikey}/campaign_event_stats/#{paths.dimension}/aggregate", {params}
      .then (res) ->
        res.data

    @find: (paths, params) ->
      FacadeV2.request "/apikeys/#{paths.apikey}/campaign_event_stats/#{paths.dimension}/find", {params}
      .then (res) ->
        res.data



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/facade/campaign_event_stats.service.coffee